import Utils from '@/ecm/common/Utils'
export default class SortItem {
    constructor () {
        this.uuid = Utils.object.getUUID()
        this.fieldTitle = ''
        this.sortOrder = 'asc'
    }
}
